import React from "react"
import Layout from "../layout/Layout"
import SEO from "../components/seo/seo"
import styled from "styled-components"
import PageHeader from "../components/pageHeader/PageHeader"
import ReservationMid from "../pagesParts/reservation/ReservationMid"
import ReservationBottom from "../pagesParts/reservation/ReservationBottom"

const StyledMainWrapper = styled.main`
  margin-top: 120px;
  background: ${props => props.theme.colors.light};
`

export default function OurMenuPage() {
  return (
    <Layout>
      <SEO
        title="Reservation"
        description="Reserve a table at Origin Restaurant (Addis Ababa, 4 Kilo behind Ambassador) and enjoy our signature chaofan and sandwiches."
      />
      <StyledMainWrapper>
        <PageHeader
          heading="Reservation"
          subheading="Reserve your table at Origin Restaurant — 4 Kilo, behind Ambassador. Fresh, fast, and full of flavor."
        />
        <ReservationMid />
        <ReservationBottom />
      </StyledMainWrapper>
    </Layout>
  )
}
